<template>
    <img
        key="img1"
        v-if="images && images.type === 1"
        class="card-img-top"
        :src="image(content.upload)"
    />
    <div
        key="img2"
        v-else-if="images && images.type === 2"
        class="nch--card-thumb d-flex align-items-center justify-content-center"
    >
        <img
            :src="image(content.upload, 'thumb')"
            style="max-width: 100%; height: auto; max-height: 280px;"
        />
    </div>
    <div
        key="img3"
        v-else-if="images && images.type === 3"
        id="nch--showcase-video-container"
        class="iframe__box"
        style="margin: auto;"
        v-html="settings.iframe"
    ></div>
</template>

<script>
import image from '../../mixins/image';

export default {
    mixins: [
        image,
    ],
    props: {
        plan: {
            type: Object,
        },
        content: {
            type: Object,
        },
    },
    computed: {
        color() {
            return this.$store.getters.COLOR;
        },
        settings() {
            return this.content && this.content.settings;
        },
        images() {
            return this.settings && this.settings.images;
        },
    },
};
</script>
